import Model from './Model';

export default class PricePoint extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'price-points';
  }
}
